<div class="row wo-form" *ngIf="commonService.appointmentDetails && commonService.contactDetails">
    <div class="col-12">
        <div class="row">
            <div class="col-3" *ngIf="isPickUpDropOff">
                <div class="form-check pl-0" [ngClass]="commonService.contactDetails.isCustomerWaiting ? 'disable' : '' ">
                    <input type="checkbox" id="pickupDropOffService" [(ngModel)]="commonService.contactDetails.isPickUpDropOffService"
                        (ngModelChange)="onSelectpickupDropOffServiceCheckBox()"
                        [disabled]="!editAppointmentService.isEdit || isWorkOrderHistory " />
                    <label class="form-check-label" translate>lblPickup/DropoffService</label>
                </div>
            </div>


            <div class="col-3" *ngIf="isPickUpDropOff">
                <div class="af-form-group" [ngClass]="commonService.contactDetails.isPickUpDropOffService ? '' : 'disable' ">
                    <label translate>lblPickupTime/DropoffTime</label>

                    <div class="lbl-info">
                        <div class="d-flex align-items-center">
                            <div class="">
                                <div class="d-flex">
                                    <input type="number" class="duration-hr form-control" placeholder="HH"
                                        [(ngModel)]="PickupHour" maxlength="2"
                                        (keyup)="MoveToDurationMinute($event,'Pickup')" min="0" max="24"
                                        [disabled]="!editAppointmentService.isEdit || isWorkOrderHistory ">
                                    <span class="p-1"> : </span>
                                    <input type="number" class="duration-min form-control"
                                        (keyup)="CheckMinute($event,'Pickup')" [(ngModel)]="PickupMinutes" min="0"
                                        max="60" #PickupminuteInput placeholder="MM"
                                        [disabled]="!editAppointmentService.isEdit || isWorkOrderHistory ">
                                </div>
                            </div>

                            &nbsp;&nbsp;
                            <div class="">
                                <div class="d-flex font22">
                                    /
                                </div>
                            </div>
                            &nbsp;&nbsp;

                            <div class="">
                                <div class="d-flex">
                                    <input type="number" class="duration-hr form-control" placeholder="HH"
                                        [(ngModel)]="DropoffHour" maxlength="2"
                                        (keyup)="MoveToDurationMinute($event,'Dropoff')" min="0" max="24"
                                        [disabled]="!editAppointmentService.isEdit || isWorkOrderHistory ">
                                    <span class="p-1"> : </span>
                                    <input type="number" class="duration-min form-control"
                                        (keyup)="CheckMinute($event,'Dropoff')" [(ngModel)]="DropoffMinutes" min="0"
                                        max="60" #DropoffminuteInput placeholder="MM"
                                        [disabled]="!editAppointmentService.isEdit || isWorkOrderHistory ">
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </div>


            <div class="col-3" *ngIf="commonService.contactDetails"
                [ngClass]="commonService.contactDetails.isPickUpDropOffService ?  'disable' : '' ">
                <div class="form-check pl-0">
                    <input type="checkbox" id="isCustomerWaiting" [(ngModel)]="commonService.contactDetails.isCustomerWaiting"
                        (ngModelChange)="onSelectCustomerWaitingCheckBox()"
                        [disabled]="!editAppointmentService.isEdit || isWorkOrderHistory " />
                    <label class="form-check-label" translate>lblCustomerWaiting</label>
                </div>
            </div>


            <div class="col-3" *ngIf="isPickUpDropOff">
                <div class="af-form-group">

                </div>
            </div>

            <div class="col-3" *ngIf="commonService.contactDetails"
                [ngClass]="commonService.contactDetails && !commonService.contactDetails.isCustomerWaiting && !commonService.contactDetails?.isPickUpDropOffService ?  '' : 'disable'">
                <div class="af-form-group">
                    <label translate>lblCustomerDropTime</label>
                    <div class="lbl-info">
                        <ng-select #select [ngModelOptions]="{standalone: true}"
                            placeholder="{{ 'lblSelectCustomerDropTime' | translate }}"
                            (change)="onCustomerDropTimeSelected($event)" [(ngModel)]="commonService.contactDetails.isKeyDrop"
                            [disabled]="!editAppointmentService.isEdit || isWorkOrderHistory ">
                            <ng-option *ngFor="let item of CustomerDropTimeDropDownValues" [value]="item.value">
                                {{item.name | translate}}
                            </ng-option>
                        </ng-select>
                    </div>
                    <ng-template #load_elseCustomerDropTime>
                        <p translate class="lbl-info">-</p>
                    </ng-template>
                </div>
            </div>

            <div class="col-3" *ngIf="commonService.contactDetails"
                [ngClass]="commonService.contactDetails && !commonService.contactDetails.isCustomerWaiting  && !commonService.contactDetails?.isPickUpDropOffService ?  '' : 'disable'">
                <div class="af-form-group">
                    <label translate>lblCustomerPickUpTime</label>
                    <div class="lbl-info">
                        <ng-select #select [ngModelOptions]="{standalone: true}"
                            placeholder="{{ 'lblSelectCustomerPickUpTime' | translate }}"
                            (change)="onCustomerPickUpTimeSelected($event)" [(ngModel)]="commonService.contactDetails.isAutoKey"
                            [disabled]="!editAppointmentService.isEdit || isWorkOrderHistory ">
                            <ng-option *ngFor="let item of CustomerPickUpTimeDropDownValues" [value]="item.value">
                                {{item.name | translate}}
                            </ng-option>
                        </ng-select>
                    </div>
                    <ng-template #load_elseCustomerPickUpTime>
                        <p translate class="lbl-info">-</p>
                    </ng-template>
                </div>
            </div>

            <div class="col-3" *ngIf="commonService.contactDetails"
                [ngClass]="commonService.contactDetails.isPickUpDropOffService ?  'disable' : ''">
                <div class="form-check pl-0">
                    <input type="checkbox" id="isOnlineCheckIn" [(ngModel)]="commonService.contactDetails.isCheckIn"
                        [disabled]="!editAppointmentService.isEdit || isWorkOrderHistory || commonService.contactDetails.workorderStatusId == 2 " />
                    <label class="form-check-label" translate>lblOnlineCheck-Infacilityselected?</label>
                </div>
            </div>

            <div class="col-3" *ngIf="commonService.contactDetails">
                <label class="text-danger" *ngIf="commonService.isRentalService && !commonService.appointmentBookedDate" translate>lblPlannigWarning</label>
                <div class="d-flex">
                    <div class="form-check pl-0 ">
                        <ng-container *ngIf="commonService.isRentalService">
                            <input type="checkbox" id="rentalCar" [(ngModel)]="commonService.contactDetails.isRentalCarSelected"
                                (ngModelChange)="onSelectRentalCarCheckBox(false)"
                                [disabled]="!editAppointmentService.isEdit || !commonService.appointmentBookedDate || isWorkOrderHistory || commonService.contactDetails.isCustomerWaiting " />
                        </ng-container>
                        <ng-container
                            *ngIf="(commonService.contactDetails.rentalVehicleId && commonService.contactDetails.rentalVehicleId!=='0' )|| commonService.isRentalService">
                            <label class="form-check-label" translate>lblAvailRentalCar</label>
                        </ng-container>
                    </div>
                    <div class="lbl-info ml-3">
                        <div
                            *ngIf="((commonService.contactDetails.rentalVehicleId && (commonService.contactDetails.rentalVehicleId!=='0')) || commonService.isRentalService ) && commonService.contactDetails.rentalVehicleId !== '-1' &&  commonService.contactDetails.rentalVehicleId!==null && commonService.contactDetails.isRentalCarSelected">
                            <span
                                *ngIf="((commonService.contactDetails.rentalVehicleId && commonService.contactDetails.rentalVehicleId!=='0') || commonService.isRentalService);else load_elseVehicle">
                                {{ commonService.contactDetails.rentalCompanyMakeName }} -
                                <span *ngIf="!commonService.genericRentalCar">
                                    {{ commonService.contactDetails.price | number:'1.2-2' }}
                                </span>
                                <span *ngIf="commonService.genericRentalCar">
                                    {{ commonService.contactDetails.priceForDisply }}
                                </span>
                            </span>
                            <ng-template #load_elseVehicle>
                                -
                            </ng-template>
                        </div>
                        <div
                            *ngIf="(commonService.contactDetails.typeId > 0 || commonService.isRentalService || commonService.isRentalService) && commonService.contactDetails.rentalVehicleId === '-1' && commonService.contactDetails.isRentalCarSelected">
                            {{ commonService.contactDetails.type }} -
                            {{ commonService.contactDetails.rentalPrice }}
                        </div>
                        <div
                            *ngIf="(commonService.contactDetails.typeId > 0 || commonService.contactDetails.type?.length > 0) && commonService.contactDetails.isRentalCarSelected && commonService.contactDetails.rentalVehicleId === null">
                            {{ commonService.contactDetails.type }} -
                            {{ commonService.contactDetails.rentalPrice }}
                        </div>

                    </div>
                </div>
                <ng-container *ngIf="commonService.isRentalService || commonService.genericRentalCar">
                    <button type="submit"
                        [disabled]="!commonService.contactDetails.isRentalCarSelected || !editAppointmentService.isEdit || isWorkOrderHistory || commonService.contactDetails.isCustomerWaiting "
                        (click)="OpenRentalCarListPopup(SelectRentalCarContent)" class="btn btn-primary mr-sm-2"
                        translate aria-label="Center Align">lblSelectCar</button>
                </ng-container>

            </div>
            <!-- Delivery time -->
            <div class="col-3">
                <div class="af-form-group">
                    <label translate>lblDeliveryTime</label>
                    <div class="lbl-info">
                        <div class="d-flex align-items-center">
                            <div class="lbl-info date mr-3">
                                <input class="form-control datePicker width100force" appAfDatepicker [ngModelOptions]="{standalone: true}"
                                  [dateTime]="false"  [(ngModel)]="commonService.DeliveryDate" [disableNextMonthDates]="true"
                                  [defaultTime]="DefaultStartTime"
                                  [isOnlyTime]="false"
                                  (ngModelChange)="onChangeDeliveryDate($event)"
                                  [disabled]="!editAppointmentService.isEdit || isWorkOrderHistory  || commonService.appointmentBookedDate===null">
                                <em class="fas fa-calendar-alt fa-lg cursordisable"></em>
                            </div>
                            <div class="date">
                                <ngb-timepicker [(ngModel)]="commonService.deliveryTimeSlot" [ngModelOptions]="{standalone: true}" (ngModelChange)="onChangeDeliveryTime($event)"></ngb-timepicker>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Finished time -->
            <div class="col-3">
                <div class="af-form-group">
                    <label translate>lblFinishedTime</label>
                    <div class="lbl-info">
                        <div class="d-flex align-items-center">
                            <div class="lbl-info date mr-3">
                                <input class="form-control datePicker width100force" appAfDatepicker [ngModelOptions]="{standalone: true}"
                                  [dateTime]="false"  [(ngModel)]="commonService.FinnishedDate" [disableNextMonthDates]="true"
                                  [defaultTime]="DefaultEndTime"
                                  [isOnlyTime]="false"
                                  (ngModelChange)="onChangeFinnishedDate($event)"
                                  [disabled]="!editAppointmentService.isEdit || isWorkOrderHistory  || DeliveryHour > 23 || DeliveryMinutes >=60 || commonService.appointmentBookedDate===null">
                                <em class="fas fa-calendar-alt fa-lg cursordisable"></em>
                              </div>
                              <div class="date">
                                <ngb-timepicker [(ngModel)]="commonService.finishTimeSlot" [ngModelOptions]="{standalone: true}" (ngModelChange)="onChangeFinnishedTime($event)"></ngb-timepicker>
                            </div>

                           
                        </div>
                    </div>
                </div>
            </div>


            <div class="col-3">
                <div class="af-form-group">
                    <label translate>lblCreatedBy</label>
                    <div class="lbl-info"
                        *ngIf="commonService.contactDetails &&  commonService.appointmentDetails.sourceCreation==='Widget';else load_elseAdmin">
                        {{commonService.contactDetails.customerName}}
                    </div>
                    <ng-template #load_elseAdmin>
                        <div class="lbl-info"
                            *ngIf="commonService.contactDetails && commonService.contactDetails.createdBy;else load_CreatedByElse">
                            {{commonService.contactDetails.createdBy}}
                        </div>
                        <ng-template class="lbl-info" #load_CreatedByElse>
                            -
                        </ng-template>
                    </ng-template>
                </div>
            </div>

            <div class="col-3">
                <div class="af-form-group">
                    <label translate>lblUpdatedBy</label>
                    <div class="lbl-info" *ngIf="commonService.contactDetails && commonService.contactDetails.updatedBy;else load_UpdatedByElse">
                        {{commonService.contactDetails.updatedBy}}
                    </div>
                    <ng-template class="lbl-info" #load_UpdatedByElse>
                        -
                    </ng-template>
                </div>
            </div>

            <div class="col-3">
                <div class="af-form-group">
                    <div class="d-flex align-items-center">
                        <label translate>lblInternalCommnets</label>
                            <a class="btn btn-ico ml-1" (click)="open(Internalcontent)">
                                <em class="fas fa-comment-alt fa-lg"></em>
                            </a>

                        <a class="btn btn-ico " (click)="ViewComment(viewContent,1)">
                            <em class="fas fa-eye fa-lg"></em>
                            <span class="position-absolute translate-middle badge rounded-pill count"
                                style="margin-top: 2px !important; background-color: #ED5153; color: #ffff;">
                                {{commonService.internalComments?.length}} </span>
                        </a>

                        
                    </div>
                    <div *ngIf="commonService.internalComments.length > 0">
                        <div class="lbl-info">
                            {{commonService.internalComments[(commonService.internalComments.length - 1)]?.comment}}
                            <a class="btn btn-ico ml-2" (click)="copyInternalComments()">
                                <em class="fas fa-copy fa-lg"></em>
                            </a>
                        </div>
                    </div>

                </div>

            </div>
            <div class="col-3" *ngIf="isDsoActive">
                <div class="af-form-group">
                    <div class="d-flex align-items-center">
                        <label translate>lblMechanicComments</label>

                        <a class="btn btn-ico" (click)="ViewComment(viewContent,2)">
                            <em class="fas fa-eye fa-lg"></em>
                            <span class="position-absolute translate-middle badge rounded-pill count"
                                style="margin-top: 2px !important; background-color: #ED5153; color: #ffff;">
                                {{commonService.mechanicComments?.length}} </span>
                        </a>
                    </div>


                </div>
            </div>
            <div class="col-3">
                <div class="af-form-group">
                    <div class="d-flex align-items-center">
                        <label translate>lblCustomerCommets</label>

                        <a class="btn btn-ico" (click)="ViewComment(viewContent,3)">
                            <em class="fas fa-eye fa-lg"></em>
                            <span class="position-absolute translate-middle badge rounded-pill count"
                                style="margin-top: 2px !important; background-color: #ED5153; color: #ffff;">
                                {{commonService.customerComments?.length}}</span>
                        </a>
                    </div>

                </div>
            </div>
            <div class="col-3">
                <div class="af-form-group">
                    <div>
                        <label translate>lblMechanic</label>
                        <div class="lbl-info">
                            {{commonService.contactDetails.plannedMechanics}}
                        </div>
                    </div>
                </div>
            </div>

            <!-- Customer key drop details -->
            <!-- <div class="col-9" *ngIf="commonService.contactDetails && isShareBoxEnabled"
                [ngClass]="commonService.contactDetails && !commonService.contactDetails.isCustomerWaiting && !commonService.contactDetails?.isPickUpDropOffService ?  '' : 'disable'">
                <div class="af-form-group row">
                    <p translate class="bold col-12">lblCustomerKeyDropInfo</p>
                    <div class="af-form-group col-3">
                        <label translate>lblLocker</label>
                        <div class="lbl-info" *ngIf="customerKeyDropInfo">
                            {{customerKeyDropInfo.locationName}}\{{customerKeyDropInfo.lockerId}}
                        </div>
                    </div>
                    <div class="af-form-group col-3">
                        <label translate>lblAssignedLockerDate</label>
                        <div class="lbl-info" *ngIf="customerKeyDropInfo">
                            {{customerKeyDropInfo.assignLockerDate | date:'short'}}
                        </div>
                    </div>
                    <div class="col-3 af-form-group">
                        <label translate>lblKeyPickUpDate</label>
                        <div class="lbl-info" *ngIf="customerKeyDropInfo">
                            {{customerKeyDropInfo.keyPickUpDate | date:'short'}}
                        </div>
                    </div>
                    <div class="col-3" *ngIf="isShareBoxEnabled">
                        <button class="btn btn-primary customize-btn ml-auto" *ngIf="customerKeyDropInfo"
                            [disabled]="customerKeyDropInfo.keyPickUpDate || disableOpenLocker"
                            (click)="openLocker(customerKeyDropInfo.id)" aria-label="Center Align"
                            translate>lblOpenLocker</button>
                    </div>
                </div>
            </div> -->
            <!-- Payment Method -->
            <div class="col-3">
                <div class="af-form-group">
                    <div>
                        <label translate>lblPaymentMethod</label>
                        <div class='lbl-info'>
                            <ng-select [ngClass]="{'disable':(!editAppointmentService.isEdit || isWorkOrderHistory )}"
                                placeholder="{{ 'lblSelectPaymentMethod' | translate }}"
                                [(ngModel)]="commonService.contactDetails.paymentMethodCode">
                                <ng-template ng-header-tmp>
                                    <span class="mbold w-66px">Code</span>
                                    <span class="mbold" translate>lblPaymentMethod</span>
                                </ng-template>
                                <ng-option *ngFor="let item of paymentMethodList" [value]="item.paymentCode">
                                    <span class="w-66px">{{item.paymentCode}}</span>
                                    <span class="mx-2 hide-ng-dropdown-panel">-</span>
                                    <span>{{item.paymentDescription}}</span>
                                </ng-option>
                            </ng-select>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Customer Key pickup details -->
            <!-- <div class="col-9" *ngIf="commonService.contactDetails && isShareBoxEnabled"
                [ngClass]="commonService.contactDetails && !commonService.contactDetails.isCustomerWaiting && !commonService.contactDetails?.isPickUpDropOffService ?  '' : 'disable'">
                <div class="af-form-group row">
                    <p translate class="bold col-12">lblCustomerKeyPickUpInfo</p>
                    <div class="af-form-group col-3">
                        <label translate>lblLocker</label>
                        <div class="lbl-info" *ngIf="mechanicKeyDropInfo">
                            {{mechanicKeyDropInfo.locationName}}\{{mechanicKeyDropInfo.lockerId}}
                        </div>
                    </div>
                    <div class="af-form-group col-3">
                        <label translate>lblAssignedLockerDate</label>
                        <div class="lbl-info" *ngIf="mechanicKeyDropInfo">
                            {{mechanicKeyDropInfo.assignLockerDate | date:'short'}}
                        </div>
                    </div>
                    <div class="col-3 af-form-group">
                        <label translate>lblKeyPickUpDate</label>
                        <div class="lbl-info" *ngIf="mechanicKeyDropInfo">
                            {{mechanicKeyDropInfo.keyPickUpDate | date:'short'}}
                        </div>
                    </div>
                </div>
            </div> -->
            <!-- Payment tearms -->
            <div class="col-3">
                <div class="af-form-group">
                    <div>
                        <label translate>lblPaymentTerms</label>
                        <div class='lbl-info'>
                            <ng-select [ngClass]="{'disable':(!editAppointmentService.isEdit || isWorkOrderHistory )}"
                                placeholder="{{ 'lblSelectPaymentTerms' | translate }}"
                                [(ngModel)]="commonService.contactDetails.paymentTermsCode">
                                <ng-template ng-header-tmp>
                                    <span class="mbold w-66px">Code</span>
                                    <span class="mbold" translate>lblPaymentTerms</span>
                                </ng-template>

                                <ng-option *ngFor="let item of paymentTermsList" [value]="item.paymentTermCode">
                                    <span class="w-66px">{{item.paymentTermCode}}</span>
                                    <span class="mx-2 hide-ng-dropdown-panel">-</span>
                                    <span>{{item.paymentTermDescription}}</span>
                                </ng-option>
                            </ng-select>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-3">
                <div class="af-form-group">
                  <label translate>lblInformation</label>
                  <div class="lbl-nfo">
                    <input type="text" class="form-control"
                      [disabled]="!editAppointmentService.isEdit "
                      [(ngModel)]="commonService.contactDetails.information" />
                  </div>
                </div>
              </div>
              <div class="col-3" *ngIf="contactDetails">
                <div class="form-check pl-0">
                    <input type="checkbox" [(ngModel)]="contactDetails.toweinCars" class="ng-pristine ng-valid ng-touched form-check-label pl-0"
                    (ngModelChange)="onSelectToweinCarCheckBox($event)"/>
                    <label class="pl-0 form-check-label" translate>lblToweinCars</label>
                </div>
            </div>
            <ng-template #Internalcontent let-modal>
                <div class="modal-header">
                    <h4 class="modal-title" id="modal-basic-title" translate>lblInternalCommnets</h4>
                    <button type="button" class="close" #closeModal id="modelButton" aria-label="Close"
                        (click)="modal.dismiss('Cross click')"><span aria-hidden="true">×</span></button>
                </div>
                <div class="modal-body">
                    <form>
                        <div class="mb-3">
                            <div class="af-form-group">
                                <label translate>lblComment</label>

                                <textarea name="" class="form-control" rows="5" [(ngModel)]="commonService.internalCommentData"
                                    [ngModelOptions]="{standalone: true}"></textarea>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="modal-footer">
                    <button type="submit" class="btn btn-primary btn-lg" [disabled]="!editAppointmentService.isEdit || commonService.internalCommentData == null" (click)="AddInternalComment()"
                        translate>lblSave</button>
                    <button type="button" class="btn btn-secondary btn-lg" (click)="modal.close('Cancel click')"
                        translate>lblCancel</button>
                </div>
            </ng-template>
            <ng-template #viewContent let-modal>
                <div class="modal-header">
                    <h4 class="modal-title" id="modal-basic-title" *ngIf="commentType===1" translate>lblInternalCommnets
                    </h4>
                    <h4 class="modal-title" id="modal-basic-title" *ngIf="commentType===2" translate>lblMechanicComments
                    </h4>
                    <h4 class="modal-title" id="modal-basic-title" *ngIf="commentType===3" translate>lblCustomerCommets
                    </h4>
                    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')"><span
                            aria-hidden="true">×</span></button>
                </div>
                <div class="modal-body table-responsive">
                    <table class="tablest1">
                        <thead>
                            <tr>
                                <th translate>lblComment</th>
                                <th translate *ngIf="commentType != 3;">lblUser</th>
                                <th translate>lblCreatedDate</th>
                                <th translate *ngIf="commentType == 1;">lblAction</th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngIf="commentType===1">
                                <ng-container *ngIf="commonService.internalComments?.length > 0; else load_else_comments">
                                    <tr *ngFor="let data of commonService.internalComments">
                                        <td class="comment-cell">
                                            <div class="comment-container">
                                                <div class="comment-content">
                                                    {{data.comment}}
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            {{data.user ? data.user : ''}}
                                        </td>
                                        <td>
                                            {{data.updatedDate | date : 'short'}}
                                        </td>
                                        <ng-container>
                                            <td>
                                                <a class="btn btn-ico" ngbTooltip="Edit" tooltipClass="custom-revert"
                                                (click)="EditComment(editContent,data)">
                                                <em class="fas fa-pencil-alt fa-lg"></em>
                                                </a>
                                                <a class="btn btn-ico" ngbTooltip="Delete" tooltipClass="custom-revert"
                                                (click)="DeleteComment(data)">
                                                <em class="far fa-trash-alt fa-lg"></em>
                                                </a>
                                            </td>
                                        </ng-container>
                                    </tr>
                                </ng-container>
                            </ng-container>
                            <ng-container *ngIf="commentType===2">
                                <ng-container *ngIf="commonService.mechanicComments?.length > 0; else load_else_comments">
                                    <tr *ngFor="let data of commonService.mechanicComments">
                                        <td class="comment-cell">
                                            <div class="comment-container">
                                                <div class="comment-content">
                                                    {{data.comment}}
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            {{data.user ? data.user : ''}}
                                        </td>
                                        <td>
                                            {{data.updatedDate | date : 'short'}}
                                        </td>
                                    </tr>
                                </ng-container>
                            </ng-container>
                            <ng-container *ngIf="commentType===3">
                                <ng-container *ngIf="commonService.customerComments?.length > 0; else load_else_comments">
                                    <tr *ngFor="let data of commonService.customerComments">
                                        <td class="comment-cell">
                                            <div class="comment-container">
                                                <div class="comment-content">
                                                    {{data.comment}}
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            {{data.updatedDate | date : 'short'}}
                                        </td>
                                    </tr>
                                </ng-container>
                            </ng-container>
                            <ng-template #load_else_comments>
                                <tr>
                                    <td colspan="4" class="no-record" translate>lblNoRecordsFound</td>
                                </tr>
                            </ng-template>
                        </tbody>
                    </table>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary btn-lg" (click)="modal.close('Cancel click')"
                        translate>lblCancel</button>
                </div>
            </ng-template>
            <ng-template #editContent let-modal>
                <div class="modal-header">
                    <h4 class="modal-title" id="modal-basic-title" translate>lblEditInternalCommnets
                    </h4>
                    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')"><span
                            aria-hidden="true">×</span></button>
                </div>
                <div class="modal-body table-responsive">
                    <form [formGroup]="editcommentform">
                        <label class="text" for="comment" translate>
                            lblComment <strong class="mlt6 required"> * </strong>
                          </label>
                          <div class="lbl-info">
                            <input formControlName="comment" class="form-control mb-2" [(ngModel)]="editCommentText">
                          </div>
                        <div *ngIf="!editcommentform.controls.comment?.valid && (editcommentform.controls.comment?.dirty || editcommentform.controls.comment?.touched)" class="help-block text-danger">
                            <span translate>lblCommentRequired</span>
                        </div>
                    </form>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary btn-lg" (click)="EditCommentDetails()" [disabled]="!editcommentform.valid"
                        translate><em class="far fa-save font16 align-top mr-2"></em>lblSave</button>
                    <button type="button" class="btn btn-secondary btn-lg" (click)="modal.close('Cancel click')"
                        translate><em class="far fa-times-circle font16 align-top mr-2"></em>lblCancel</button>
                </div>
            </ng-template>
        </div>
    </div>
</div>


<ng-template #SelectRentalCarContent let-modal>
    <div class="modal-header">
        <h2 class="modal-title" translate>lblSelectRentalCar</h2>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss(false)">
            <span aria-hidden="true">×</span>
        </button>
    </div>
    <div class="modal-body p-0 ">
        <div class="popup-vcenter ">
            <div class="flgrow">


                <ng-container>
                    <div class="">
                        <div class=" table-responsive">
                            <table class="tablest1" *ngIf="!commonService.genericRentalCar">
                                <thead>
                                    <tr>
                                        <th id="Brand" scope="col" translate>lblBrand</th>
                                        <th id="LicencePlate" scope="col" translate>lblRegNumber</th>
                                        <th id="Model" scope="col" translate>lblModel</th>
                                        <th id="Price" scope="col" translate>lblPrice</th>
                                        <th id="Actions" scope="col" style="width:75px" class="text-center" translate>
                                            lblAction</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <ng-container *ngIf="commonService.availRentalCarList?.length>0; else load_NotFound_Search">
                                        <tr *ngFor="let car of commonService.availRentalCarList; let i=index">
                                            <td>
                                                {{car.makeName}}
                                            </td>
                                            <td>
                                                {{car.licensePlate}}
                                            </td>
                                            <td>
                                                {{car.model}}
                                            </td>
                                            <td>
                                                {{car.price}}
                                            </td>
                                            <td class="text-center" style="width:100px">
                                                <input name="Search" type="radio" [(ngModel)]="selectedRentalCarId"
                                                    [value]="car.vehicleId" />
                                            </td>

                                        </tr>

                                    </ng-container>
                                    <ng-template #load_NotFound_Search>
                                        <tr>
                                            <td colspan="8" class="no-record" translate>lblNoRecordsFound</td>
                                        </tr>
                                    </ng-template>
                                </tbody>
                            </table>
                            <table class="tablest1" *ngIf="commonService.genericRentalCar">
                                <thead>
                                    <tr>
                                        <th id="brand" translate>lblType</th>
                                        <th id="price" translate>lblPrice</th>
                                        <th id="Actions" scope="col" style="width:75px" class="text-center" translate>
                                            lblAction</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <ng-container *ngIf="commonService.genericRentalCarList?.length>0; else load_NotFound_Search">
                                        <tr *ngFor="let car of commonService.genericRentalCarList; let i=index">
                                            <td>
                                                {{car.type}}
                                            </td>
                                            <td>
                                                {{car.price}}
                                            </td>
                                            <td class="text-center"style="width:100px">
                                                <input name="Search" type="radio"
                                                    [(ngModel)]="selectedGenericRentalCarId" [value]="car.typeId" />
                                            </td>

                                        </tr>

                                    </ng-container>
                                    <ng-template #load_NotFound_Search>
                                        <tr>
                                            <td colspan="3" class="no-record" translate>lblNoRecordsFound</td>
                                        </tr>
                                    </ng-template>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>

    <div class="modal-footer">
        <button type="submit" [disabled]="!selectedRentalCarId && !selectedGenericRentalCarId"
            class="btn btn-primary mr-sm-2" (click)="onRentalCarSelected();modal.dismiss(false)" translate
            aria-label="Center Align">lblSelect</button>
        <button (click)="modal.dismiss(false)" class="btn btn-secondary" aria-label="Center Align"
            translate>lblCancel</button>
    </div>
</ng-template>